import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./controllers/AuthProvider";
import { App } from "./views/App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
